import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
export default class extends ApplicationController {
  static targets = ["hm0_output"];
  connect() {
    super.connect();
    var self = this;
    if (
      $("#partial-content").length &&
      $("#partial-content").text().trim() == "Chargement en cours ..."
    ) {
      //on est sur le show
      setTimeout(() => this.conges_hm_ajax(), 300);
    }
    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });
      $("#filterrific_with_duree_inf").on("input", function () {
        $("#target_duree_inf").val($("#filterrific_with_duree_inf").val());
      });
      $("#filterrific_with_duree_sup").on("input", function () {
        $("#target_duree_sup").val($("#filterrific_with_duree_sup").val());
      });
      $("#target_duree_inf").on("input", function () {
        $("#filterrific_with_duree_inf").val($("#target_duree_inf").val());
      });
      $("#target_duree_sup").on("input", function () {
        $("#filterrific_with_duree_sup").val($("#target_duree_sup").val());
      });
      $("#filterrific_operation_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".operation").show();
        } else {
          $(".operation").hide();
        }
      });
      $("#filterrific_justificatif").click(function () {
        if ($(this).is(":checked")) {
          $(".justificatif").show();
        } else {
          $(".justificatif").hide();
        }
      });
      $("#filterrific_soumisle").click(function () {
        if ($(this).is(":checked")) {
          $(".soumis").show();
        } else {
          $(".soumis").hide();
        }
      });
      if ($("#filterrific_operation_hide").is(":checked")) {
        $(".operation").show();
      } else {
        $(".operation").hide();
      }
      if ($("#filterrific_soumisle").is(":checked")) {
        $(".soumis").show();
      } else {
        $(".soumis").hide();
      }
      var targetElement = document.getElementById("mySidebar");
      targetElement.addEventListener("scroll", (event) => {
        var element = document.getElementById("mySidebar");
        document.getElementById("scrollevel").value = element.scrollTop;
      });

      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const bonsDeCommandeParam = url.searchParams.get("previous_record");

      if (bonsDeCommandeParam != null) {
         
          $("#conge_" + bonsDeCommandeParam + " td").addClass("highlighted-td");
          $("#conge_" + bonsDeCommandeParam).get(0).scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }


  rerender() {
    var row = $("#search");
    var row2 = $("#quick_sort");
    row.insertAfter(row2);
  }
  conges_hm_ajax() {
    if (this.current_app && this.conge_id) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/conges/show_ajax_for_hm?conge_id=" +
        this.conge_id +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-content").html("");
          $("#partial-content").html(text);
        })
      );
    }
  }
  get current_app() {
    return this.data.get("app");
  }
  get conge_id() {
    return this.data.get("congeid");
  }
  get url_solution() {
    return this.data.get("urlsolution");
  }
}
